import { render } from "./NewUserModal.vue?vue&type=template&id=5784ac3b&scoped=true&lang=true"
import script from "./NewUserModal.vue?vue&type=script&lang=js"
export * from "./NewUserModal.vue?vue&type=script&lang=js"

import "./NewUserModal.vue?vue&type=style&index=0&id=5784ac3b&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784ac3b"]])

export default __exports__